import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';

export const slideshowMax = tabletMax.replace('768', '767');
const slideshowMin = slideshowMax.replace('max', 'min').replace('767', '768');

export const Container = styled.div`
  background-color: ${(props) => props.theme.black};
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 60px;
`;

export const Header = styled.div`
  background-color: ${(props) => props.theme.darkGrey};
  height: 60px;
  width: 100%;
  display: flex;
  position: fixed;
  top: 0;
  z-index: 2;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
`;

export const TabContent = styled.div`
  display: flex;
  margin: 5px auto;
`;

const GreyDivider = css`
  content: '';
  position: absolute;
  bottom: 50%;
  transform: translateY(50%);
  width: 1px;
  height: 38px;
  background-color: ${({ theme }) => theme.backgroundLighter};
  z-index: 1;
  transition: background-color 300ms linear;
`;

export const TabText = styled.p`
  font-size: 16px;
  transition: color 300ms linear;
  display: flex;
  align-items: center;
  font-weight: 600;

  svg {
    font-size: 20px;
  }
`;

export const Tab = styled.button<{ active: boolean }>`
  position: relative;
  height: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  background-color: ${({ theme, active }) => theme[active ? 'primary' : 'white']};
  transition: background-color 300ms linear;

  &:not(:last-child):after {
    ${GreyDivider}
    right: -1px;
  }

  &:not(:first-child):before {
    ${GreyDivider}
    left: 0;
    background-color: transparent;
  }

  &:first-child {
    border-top-left-radius: 26px;
    border-bottom-left-radius: 26px;
  }

  &:last-child {
    border-top-right-radius: 26px;
    border-bottom-right-radius: 26px;
  }

  ${({ active, theme }) =>
    active
      ? `
      &:not(:last-child):after {
        background-color: transparent;
      }
      &:not(:first-child):before {
        background-color: ${theme.primary};
      }
      `
      : ''}

  &:hover {
    background-color: ${({ theme }) => theme.primary};

    ${TabText} {
      color: ${({ theme }) => theme.white};
    }

    &:not(:last-child):after {
      background-color: transparent;
    }
    &:not(:first-child):before {
      ${({ theme }) => `background-color: ${theme.primary};`}
    }
  }

  @media (${slideshowMax}) {
    padding: 0 18px;
  }

  @media (${slideshowMin}) {
    ${TabText} {
      svg {
        margin-right: 8px;
      }
    }
  }

  ${TabText} {
    color: ${({ theme, active }) => theme[active ? 'white' : 'textDark']};
  }
`;

export const SliderBox = styled.div`
  width: 100%;
  min-height: 100%;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .swiper-slide {
    display: flex;
    align-items: center;

    &-active {
      z-index: 1;
    }
  }
`;

export const AdContainer = styled.div`
  position: fixed;
  width: 320px;
  bottom: 0;
  right: 0;
  left: 0;
  margin: 0 auto;
  z-index: 2;

  @media (${slideshowMax}) {
    left: auto;
  }
`;
